var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-backdrop"}),_c('div',{staticClass:"loading-content"},[_c('img',{staticClass:"loading-logo",attrs:{"src":"/img/logos/logo-negativo.png","alt":"S.O.S Contingencias"}}),_c('div',{staticClass:"loading-line"},[_c('div',{staticClass:"loading-line-fill"})])])])
}]

export { render, staticRenderFns }